// Campaign-specific configurations
// Similar to destination.js, this file contains campaign-specific content and settings

export const campaignConfig = {
  "uptosnowgood": {
    heroVideo: {
      desktop: "https://d1puf2nnbcyl9q.cloudfront.net/UTSG+16-9+v3.mov",
      mobile: "https://d1puf2nnbcyl9q.cloudfront.net/UTSG+mobile+v2.mov",
    },
    howItWorks: {
      steps: [
        "Sign in to your Sotravel account",
        'Click on the "#UPTOSNOWGOOD" to spin the wheel',
        "Promo code is valid for 2 weeks",
      ],
    },
    buttonText: "#UPTOSNOWGOOD",
  },
  "noragrets": {
    heroVideo: {
      desktop: "https://d1puf2nnbcyl9q.cloudfront.net/UTSG+16-9+v3.mov",
      mobile: "https://d1puf2nnbcyl9q.cloudfront.net/UTSG+mobile+v2.mov",
    },
    howItWorks: {
      steps: [
        "Sign in to your Sotravel account",
        'Click on the "#NORAGRETS" to participate in the draw',
        "On 21 July, 8pm, winners will receive their promo code via the Sotravel App",
        "Promo code is valid till 3rd August",
      ],
    },
    buttonText: "#NORAGRETS",
  },
  "eu-go-i-go": {
    heroVideo: {
      desktop: "https://d1puf2nnbcyl9q.cloudfront.net/1772454716354_website_eugoigo.mp4",
      mobile: "https://d1puf2nnbcyl9q.cloudfront.net/1772417727404_20260302-091328.mp4",
    },
    heroLogo: "/images/eu-go-i-go-logo-white.png",
    howItWorks: {
      steps: [
        "Sign in to your Sotravel account",
        'Click on the "#EU GO, I GO!" to spin the wheel',
        "Winners announced 17 Mar. Promo codes valid 17-31 Mar",
      ],
    },
    buttonText: "#EU GO, I GO!",
  },
  "aurora": {
    // 16:9 landscape master from Maomi — single asset reused on mobile until a
    // portrait cut is delivered (object-cover crops to the centre on portrait
    // viewports, which preserves the green-pillar focal point).
    heroVideo: {
      desktop: "https://d1puf2nnbcyl9q.cloudfront.net/1777270287436_20260427-130526.mp4",
      mobile: "https://d1puf2nnbcyl9q.cloudfront.net/1777270287436_20260427-130526.mp4",
    },
    // Final "Aurora Promise" logo from Justin (2026-07-17), served from CloudFront —
    // sotravel_fe public/ assets don't reliably deploy, so never reference /images/ here.
    heroLogo: "https://d1puf2nnbcyl9q.cloudfront.net/1784267938955_aurora-promise-logo.png.png",
    // The aurora page renders its own dark-mode body (promises/spotlight/FAQ), so the
    // generic how-it-works strip never shows — kept empty for config-shape parity.
    howItWorks: {
      steps: [],
    },
    buttonText: "Aurora Promise",
  },
};

// Helper function to get campaign config with fallback
export const getCampaignConfig = (campaignSlug) => {
  return campaignConfig[campaignSlug] || campaignConfig["uptosnowgood"]; // Default fallback
};
